import gql from 'graphql-tag';

export class FormInput {
  id: number;
  collectionpointId: number;
  legacyAppId: string;
  name: string;
  notes: string;
  phone: string;
  collectorId: number;
  userId: number;
  adrNumber: string;
  adrExpDate: Date;
  adrFileId: number;
  licenseExpDate: Date;
  licenseFileId: number;
  signFileId: number;
  isActive: boolean;
  isApproved: boolean;
  approvedBy: string;
  approvedDate: Date;

  constructor() {
    this.id = undefined;
    this.collectionpointId = undefined;
    this.legacyAppId = undefined;
    this.name = undefined;
    this.notes = undefined;
    this.phone = undefined;
    this.collectorId = undefined;
    this.userId = undefined;
    this.adrNumber = undefined;
    this.adrExpDate = undefined;
    this.adrFileId = undefined;
    this.licenseExpDate = undefined;
    this.licenseFileId = undefined;
    this.signFileId = undefined;
    this.isActive = undefined;
    this.isApproved = undefined;
    this.approvedBy = undefined;
    this.approvedDate = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollectionpointsContacts($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionpointsContacts(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        collectionpointId
        code
        name
        firstName
        middleName
        lastName
        type
        notes
        companyVat
        companyTaxOffice
        addressLine1
        addressLine2
        addressArea
        addressCity
        addressNomos
        addressDistrict
        postalCode
        phone
        mobile
        fax
        email
        recordDate
        legacyAppId
        isActive
        collectionpoint {
          id
          name
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCollectionpointsContactById($id: Int) {
    getCollectionpointsContactById(id: $id) {
      id
      collectionpointId
      code
      name
      firstName
      middleName
      lastName
      type
      notes
      companyVat
      companyTaxOffice
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      addressDistrict
      postalCode
      phone
      mobile
      fax
      email
      recordDate
      legacyAppId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      collectionpoint {
        id
        name
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollectionpointsContact($data: CollectionpointsContactInput) {
    addCollectionpointsContact(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollectionpointsContact($data: CollectionpointsContactInput) {
    updateCollectionpointsContact(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollectionpointsContact($id: Int) {
    deleteCollectionpointsContact(id: $id)
  }
`;
